import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './locales';
import global from '@/components/global';

import {
	Button,
	Table,
	Modal,
	Popover,
	Select,
	Input,
	Pagination,
	Drawer,
	Menu,
	Spin,
	Empty,
	ConfigProvider,
	Collapse,
	FormModel,
	Row,
	Col,
	Checkbox,
	Message,
	DatePicker
} from 'ant-design-vue';

import '@/style/main.less';
import '@/utils/rem';

import { isMac } from '@/utils/const';

if (isMac) {
	document.body.classList.add('is-mac');
}

// 注册 ant-design-vue 组件
Vue.use(ConfigProvider);
Vue.use(Button);
Vue.use(Table);
Vue.use(Modal);
Vue.use(Popover);
Vue.use(Select);
Vue.use(Input);
Vue.use(Pagination);
Vue.use(Drawer);
Vue.use(Menu);
Vue.use(Spin);
Vue.use(Empty);
Vue.use(Collapse);
Vue.use(FormModel);
Vue.use(Row);
Vue.use(Col);
Vue.use(Checkbox);
Vue.use(Message);
Vue.use(DatePicker);

Vue.prototype.$message = Message;

Vue.use(global);

Vue.config.productionTip = false;

new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app');
